module.exports = __webpack_public_path__ + "static/media/l12_voice_nine_v2.dfe2b7e6.mp3";